var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.9608 2.11037L5.46078 4.17037C4.41078 4.57037 3.55078 5.81037 3.55078 6.94037V15.0404C3.55078 15.8504 4.08078 16.9204 4.73078 17.4004L10.2308 21.5104C11.2008 22.2404 12.7908 22.2404 13.7608 21.5104L19.2608 17.4004C19.9108 16.9104 20.4408 15.8504 20.4408 15.0404V6.94037C20.4408 5.82037 19.5808 4.57037 18.5308 4.18037L13.0308 2.12037C12.4708 1.90037 11.5308 1.90037 10.9608 2.11037Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10.5C14.5 9.12 13.38 8 12 8C10.62 8 9.5 9.12 9.5 10.5C9.5 11.62 10.24 12.55 11.25 12.87V15.5C11.25 15.91 11.59 16.25 12 16.25C12.41 16.25 12.75 15.91 12.75 15.5V12.87C13.76 12.55 14.5 11.62 14.5 10.5Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldSecurity);
export default __webpack_public_path__ + "static/media/shield-security.aa769ad4bf70fa89063bbf3676390267.svg";
export { ForwardRef as ReactComponent };